import React from 'react';
import { Platform, TouchableOpacity, View, ViewStyle } from 'react-native';
import { FixedViewV2 } from './FixedViewV2';
import { useDraggableHeight } from '@/hooks/useDraggableHeight';
import { RootSiblingPortal } from 'react-native-root-siblings';
import { Drag } from '../Drag';
import { KTouchableOpacity } from '../RtlLayout/Touchable';

/**
 * 半屏吸底的简版Popup组件
 */
export function FixedPopup(props: {
    // 是否展示
    visible: boolean;
    // deppmask
    deepMask?: boolean;
    // 点击关闭
    onClose?: any;
    // 是否展示遮罩，默认为true
    showMask?: boolean;
    // 点击遮罩是否关闭，默认为true
    maskCloseable?: boolean;
    // 是否可以拖拽关闭
    draggable?: boolean;
    children: any;
    style?: ViewStyle;
}) {
    const { visible, deepMask = false, onClose, showMask = true, maskCloseable = true, draggable = false, style = {} } = props;
    const { height } = useDraggableHeight();

    const onClickMask = () => {
        if (maskCloseable) {
            onClose?.();
        }
    };

    return visible ? (
        // Popup组件需要提升到根组件
        <RootSiblingPortal>
            <FixedViewV2
                className="FixedPopup"
                style={[
                    { zIndex: 1000 },
                    Platform.OS === 'web'
                        ? {
                              height: '100vh',
                              backgroundColor: deepMask ? 'rgba(0, 0, 0, 0.72)' : 'rgba(0,0,0,0.3)',
                              position: 'absolute',
                          }
                        : {
                              height,
                              width: '100%',
                              backgroundColor: deepMask ? 'rgba(0, 0, 0, 0.72)' : 'rgba(0,0,0,0.3)',
                              position: 'absolute',
                              top: 0,
                          },
                    style,
                ]}>
                {showMask ? (
                    <KTouchableOpacity
                        style={{"position":"absolute","top":"0rem","bottom":"0rem","width":"100%","height":"100%"}}
                        activeOpacity={1}
                        onPress={onClickMask}>
                        {draggable ? (
                            <Drag visible onShouldClose={onClose} style={{"position":"absolute","bottom":"0rem","width":"100%"}}>
                                <KTouchableOpacity activeOpacity={1}>{props.children}</KTouchableOpacity>
                            </Drag>
                        ) : (
                            <View style={{"position":"absolute","bottom":"0rem","width":"100%"}}>
                                <KTouchableOpacity activeOpacity={1}>{props.children}</KTouchableOpacity>
                            </View>
                        )}
                    </KTouchableOpacity>
                ) : (
                    props.children
                )}
            </FixedViewV2>
        </RootSiblingPortal>
    ) : null;
}
